import PropTypes from 'prop-types';

import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';

import styles from './index.styl';

/**
 * Компонент отображает дополнительные стрелки навигации над слайдером
 */
function HeaderArrows(props) {
  const {
    theme,
    nextHandler,
    prevHandler,
    isStart,
    isEnd,
  } = props;

  // навигация не имеет смысла
  if (isStart && isEnd) return null;

  const {
    controls: {
      drum: {
        headerArrows: {
          const: {
            Left,
            Right,
            width,
            height,
          },
          basic: {
            idle: {
              color: idleColor,
            },
            hover: {
              color: hoverColor,
            },
            inactive: {
              color: inactiveColor,
            },
          },
        },
      },
    },
  } = theme;

  return (
    <div className={styles.headerArrows}>
      <style jsx>{`
        .${styles.arrow}
          :global(svg)
            color ${idleColor}

          &:hover
            :global(svg)
              color ${hoverColor}

        .${styles._inactive}
        .${styles._inactive}:hover
          :global(svg)
            color ${inactiveColor}
      `}</style>
      <div className={cx(styles.arrow, isStart && styles._inactive)} onClick={prevHandler}>
        <Left height={height} width={width} />
      </div>
      <div className={cx(styles.arrow, isEnd && styles._inactive)} onClick={nextHandler}>
        <Right height={height} width={width} />
      </div>
    </div>
  );
}

const svgContract = '{ color }';

HeaderArrows.propTypes = {
  /**
   * Обработчик для перехода слайдера вперед
   */
  nextHandler: PropTypes.func.isRequired,

  /**
   * Обработчик для перехода слайдера назад
   */
  prevHandler: PropTypes.func.isRequired,

  /**
   * Теккущая позиция в начала списка
   */
  isStart: PropTypes.bool,

  /**
   * Теккущая позиция в конце списка
   */
  isEnd: PropTypes.bool,

  /** @ignore */
  theme: themePropTypes(`
    {
      controls: {
        drum: {
          headerArrows: {
            const: {
              Left,
              Right,
              width,
              height,
            }
            basic: {
              idle: ${svgContract},
              hover: ${svgContract},
              inactive: ${svgContract},
            }
          },
        },
      },
    }
  `),
};

export default withTheme(HeaderArrows);
